import { useScrollCompact } from '../../hooks/useScrollCompact';
import './PageStickyChrome.css';

const PageStickyChrome = ({ className = '', children }) => {
  const isCompact = useScrollCompact();

  return (
    <div
      className={`page-sticky-chrome${isCompact ? ' page-sticky-chrome--compact' : ''}${className ? ` ${className}` : ''}`}
    >
      {children}
    </div>
  );
};

export default PageStickyChrome;
